<div class="login-container">
    <div class="background">
        <div class="shape"></div>
        <div class="shape"></div>
    </div>
    <form [formGroup]="forgotPasswordForm" (ngSubmit)="submitForgotPassword()" novalidate>


        <div class="form-group text-center" *ngIf="!emailSent; else emailSentBlock">
            <label class="mb-4">Enter your email and we`ll send you a link <br> to reset your password. </label>
            <input type="email" class="form-control" formControlName="email" placeholder="Enter email">
        </div>

        <ng-template #emailSentBlock>
            <div class="email-success text-center">
                link has been sent succesfully, please check your inbox.
            </div>
        </ng-template>

        <button type="submit" *ngIf="!emailSent" >Submit</button>
        <div class="d-flex mt-4 justify-content-center">
            <a class="forgotPassword" routerLink="/login"> &larr; Back to Login</a>
        </div>
    </form>
</div>